import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { BooleanCons, NumberCons} from 'src/app/constants/const';
import { CalculationService } from 'src/app/services/calculation.service';
import { PatternService } from 'src/app/services/pattern.service';
import { UtilitiesCalculator } from '../../model/http/myActivity.model';
@Component({
  selector: 'app-utilities-calculator',
  templateUrl: './utilities-calculator.component.html',
  styleUrls: ['./utilities-calculator.component.scss']
})
export class UtilitiesCalculatorComponent implements OnInit {
  costPublic = NumberCons.zero;
  utilityPercentage = NumberCons.zero;
  subscription = new Subscription();
  disabledAccept = BooleanCons.false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: UtilitiesCalculator,
              private dialogRef: MatDialogRef<UtilitiesCalculator>,
              private calculationService: CalculationService,
              public patternService: PatternService) { }
  ngOnInit(): void {
    this.costPublic = this.data.costThePublic;
    this.utilityPercentage = this.data.utilityPercentage;
    this.disabledAccept = this.data.utilityPercentage <= 0;
  }
  closeModal(): void {
    this.dialogRef.close();
  }
  accept(): void{
    this.data.costThePublic = Number(this.costPublic);
    this.data.utility =  this.calculationService.calculateUtility(Number(this.data.costPerPiece), Number(this.costPublic));
    this.data.utilityPercentage = Number (this.utilityPercentage);
    this.data.newUtilityAmount = this.calculationService.calculateAmountUtility(this.data.quantity, this.data.utility);
    this.dialogRef.close(this.data);
  }
  costPublicCalculed(): void {
    this.utilityPercentage = this.calculationService.calculateUtilitiesPercentage(Number(this.data.costPerPiece), Number(this.costPublic));
    this.disabledAccept = this.utilityPercentage <= 0;
  }
  utilitieCalculed(): void {
    this.costPublic = this.calculationService.calculateCostPublic(Number(this.data.costPerPiece), Number(this.utilityPercentage));
    this.disabledAccept = this.utilityPercentage <= 0;
  }
}
